import { useCallback, useEffect, useRef } from 'react';

import { useActionCable } from '~/lib/webSocket/useActionCable';

interface CurrentStatusSender {
  notifyNewStudentInClass: (delayMs?: number) => void;
}

export const useCurrentStatusSender = (
  classId: string,
): CurrentStatusSender => {
  const channel = useActionCable(
    classId ? { channel: 'KlassCurrentStatusChannel', classId } : null,
    {},
  );

  const sendRef = useRef(channel.send);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    sendRef.current = channel.send;
  }, [channel.send]);

  useEffect(() => {
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);

  const notifyNewStudentInClass = useCallback((delayMs = 3000): void => {
    // Delay avoids a race where current status cache can miss a new student.
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    const send = sendRef.current;

    timeoutRef.current = setTimeout(() => {
      send?.({
        event: 'newStudentInClass',
      });
    }, delayMs);
  }, []);

  return {
    notifyNewStudentInClass,
  };
};
